// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_82a27a64","iconWrapper":"_3d21dfef","nonTradeIconHeightFix":"_85e01e3d","vipText":"_33242fc5"};